import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CSS = `
.cg-chip {
  display: inline-flex; align-items: center; gap: var(--space-2);
  font-family: var(--font-sans); font-weight: var(--weight-semibold); font-size: var(--text-sm);
  padding: 7px 14px 7px 10px; border-radius: var(--radius-pill);
  background: var(--surface-card); color: var(--text-body);
  border: 1px solid var(--border-default); cursor: pointer; white-space: nowrap;
  box-shadow: var(--shadow-xs);
  transition: background var(--duration-fast) var(--ease-standard),
              border-color var(--duration-fast) var(--ease-standard),
              color var(--duration-fast) var(--ease-standard);
}
.cg-chip:hover { background: var(--slate-50); border-color: var(--border-strong); }
.cg-chip__dot {
  width: 10px; height: 10px; border-radius: 50%;
  background: var(--_c, var(--brand-primary)); flex-shrink: 0;
}
.cg-chip svg { width: 15px; height: 15px; }
.cg-chip__count {
  font-size: var(--text-2xs); color: var(--text-subtle);
  font-weight: var(--weight-semibold);
}
.cg-chip--active {
  background: var(--_c, var(--brand-primary)); border-color: transparent; color: #fff;
}
.cg-chip--active .cg-chip__dot { background: rgba(255,255,255,.9); }
.cg-chip--active .cg-chip__count { color: rgba(255,255,255,.8); }
.cg-chip--active:hover { background: var(--_c, var(--brand-primary)); filter: brightness(.95); }
`;
function injectStyles() {
    if (typeof document !== 'undefined' && !document.getElementById('cg-categorychip-css')) {
        const s = document.createElement('style');
        s.id = 'cg-categorychip-css';
        s.textContent = CSS;
        document.head.appendChild(s);
    }
}
const CATEGORY_COLORS = {
    dining: 'var(--cat-dining)', culture: 'var(--cat-culture)', nature: 'var(--cat-nature)',
    shopping: 'var(--cat-shopping)', nightlife: 'var(--cat-nightlife)', transit: 'var(--cat-transit)',
    stay: 'var(--cat-stay)', services: 'var(--cat-services)',
};
export function CategoryChip({ label, category, color, icon, count = null, active = false, className = '', style, ...rest }) {
    injectStyles();
    const c = color ?? (category ? CATEGORY_COLORS[category] : undefined);
    const cls = ['cg-chip', active ? 'cg-chip--active' : '', className].filter(Boolean).join(' ');
    const chipStyle = c ? { ...style, '--_c': c } : style;
    return (_jsxs("button", { className: cls, style: chipStyle, "aria-pressed": active, ...rest, children: [icon ?? _jsx("span", { className: "cg-chip__dot" }), label, count != null && _jsx("span", { className: "cg-chip__count", children: count })] }));
}
